import { BambooSyncConfigError } from "pages/bamboo-hr/models/bamboo-sync-config-error";

export class BambooSyncConfigStatus  {

    public hasConfigBeenSetOnce: boolean = false;
    public isInError: boolean = false;
    public errors: BambooSyncConfigError[] = [];

}
